import styled from 'styled-components';

export const AutoSuggestDropdownCheckboxStyled = styled.div`
  position: relative;

  .body_autosuggest {
    font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
    color: ${({ theme, disabled }) =>
    disabled ? theme.COLORS.GRAY_24 : theme.COLORS.GRAY_30};
    background: ${({ theme, disabled }) =>
    disabled ? theme.COLORS.GRAY_36 : theme.COLORS.WHITE_1};
    font-size: ${({ theme, fontSize }) =>
    fontSize ? fontSize : theme.FONT.SIZE.S16};
    border: 1px solid
      ${({ disabled, theme }) =>
    disabled ? theme.COLORS.GRAY_22 : theme.COLORS.GRAY_10};
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 8px;
    padding: 9px 12px;
    box-sizing: border-box;
    height: ${({ heightInput }) => (heightInput ? heightInput : '48px')};
    column-gap: 5px;
    cursor: pointer;

    .value_show {
      display: flex;
      align-items: center;
      gap: 4px;
      flex-wrap: nowrap;
      flex: 1;
      min-width: 0;
      overflow: hidden;

      &.txt_color {
        color: ${({ theme }) => theme.COLORS.GRAY_23};
      }
      &.text_placeholder {
        color: ${({ theme, disabled, fontColorPlaceholder }) =>
    disabled && fontColorPlaceholder
      ? fontColorPlaceholder
      : disabled
        ? theme.COLORS.GRAY_24
        : ''};
      }
      .selected_item {
        white-space: nowrap;
        overflow: hidden;
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        text-overflow: ellipsis;
      }

      .remaining_count {
        flex-shrink: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        width: 41px;
        height: 24px;
        border-radius: 16px;
        background-color: #fff6dd;
        color: #ffa438;
        font-size: 14px;
        font-weight: 500;
        padding: 2px 8px;
        margin-left: 4px;
        white-space: nowrap;
      }
    }

    .right_icons {
      display: flex;
      align-items: center;
      gap: 5px;
      flex-shrink: 0;
    }

    .clear_all {
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    &.open {
      box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
      border-radius: 8px 8px 0px 0px;
      border-bottom: none;
    }
  }

  .otp_show {
    width: calc(100% - 1.6px);
    min-width: ${({ minwidth }) => (minwidth ? minwidth : 'unset')};
    max-height: 232px;
    position: absolute;
    z-index: 2;
    border: 1px solid ${({ theme }) => theme.COLORS.GRAY_10};
    font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
    color: ${({ theme }) => theme.COLORS.GRAY_23};
    font-size: ${({ theme }) => theme.FONT.SIZE.S16};
    display: flex;
    flex-direction: column;
    background: ${({ theme }) => theme.COLORS.WHITE_1};
    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);

    &.down {
      top: 44px;
      bottom: auto;
      border-radius: 0px 0px 8px 8px;
    }

    &.up {
      bottom: 44px;
      top: auto;
      border-radius: 8px 8px 0px 0px;
    }

    .group_opt_top {
      border-bottom: 1px solid ${({ theme }) => theme.COLORS.GRAY_10};
      display: flex;
      align-items: center;
      flex-direction: column;

      .all_zone {
        padding: 9.6px 0px;
        cursor: pointer;
        border-bottom: 1px solid ${({ theme }) => theme.COLORS.GRAY_10};
        width: calc(100% - 20px);
        display: flex;
        align-items: center;
        gap: 8px;

        &:last-child {
          border-bottom: none;
        }

        &.select {
          background: ${({ theme }) => theme.COLORS.BLUE_32};
        }

        input[type='checkbox'] {
          width: 16px;
          height: 16px;
          min-width: 16px;
          border-radius: 4px;
          border: 1px solid #d1d5db;
          appearance: none;
          outline: none;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        input[type='checkbox']:checked {
          background-color: ${({ theme }) => theme.COLORS.BLUE_21};
          border-color: ${({ theme }) => theme.COLORS.BLUE_21};
        }

        input[type='checkbox']:checked::after {
          content: '✔';
          color: ${({ theme }) => theme.COLORS.PURPLE_1};
          font-size: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .lbl_opt {
          flex: 1;
          font-size: ${({ theme }) => theme.FONT.SIZE.S16};
          font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
          color: ${({ theme }) => theme.COLORS.PURPLE_1};
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          display: block;
        }
      }
    }

    .render_opt {
      display: flex;
      flex-direction: column;
      padding: 6px 2px;
      max-height: 180px;

      .box_search {
        margin: 0 5px 12px;
        position: relative;
        padding: 5.6px 12px;
        border-radius: 8px;
        border: 1px solid ${({ theme }) => theme.COLORS.GRAY_10};

        .svg_search {
          display: flex;
          cursor: pointer;
          position: absolute;
          top: 8px;
          right: 8px;
        }

        .input_search {
          width: calc(100% - 25px);
          font-size: ${({ theme }) => theme.FONT.SIZE.S14};
          font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
          border: none;
          color: ${({ theme }) => theme.COLORS.GRAY_23};
          &::-webkit-input-placeholder {
            color: ${({ theme }) => theme.COLORS.GRAY_30};
          }
        }
      }

      .opt_zone_box {
        margin-left: 8px;
        padding-bottom: 10px;
        overflow: auto;

        ::-webkit-scrollbar {
          width: 6px;
          height: 6px;
        }

        ::-webkit-scrollbar-thumb {
          background: #cccccc;
          border-radius: 50px;
        }

        ::-webkit-scrollbar-thumb:hover {
          background: #c2c2c2;
        }

        .opt_box {
          color: ${({ theme }) => theme.COLORS.GRAY_23};
          font-size: ${({ theme }) => theme.FONT.SIZE.S16};
          border-bottom: 1px solid ${({ theme }) => theme.COLORS.GRAY_10};
          cursor: pointer;
          width: 95%;
          min-height: 33.2px;
          display: flex;
          align-items: center;
          padding: 5px 0px;

          input[type='checkbox'] {
            width: 16px;
            height: 16px;
            min-width: 16px;
            border-radius: 4px;
            border: 1px solid #d1d5db;
            appearance: none;
            outline: none;
            cursor: pointer;
            margin-right: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          input[type='checkbox']:checked {
            background-color: ${({ theme }) => theme.COLORS.BLUE_21};
            border-color: ${({ theme }) => theme.COLORS.BLUE_21};
          }

          input[type='checkbox']:checked::after {
            content: '✔';
            color: ${({ theme }) => theme.COLORS.PURPLE_1};
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .lbl_opt {
            flex: 1;
            font-size: ${({ theme }) => theme.FONT.SIZE.S16};
            font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
            color: ${({ theme }) => theme.COLORS.PURPLE_1};
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: block;
          }

          &:last-child {
            padding-bottom: 0px;
            border-bottom: none;
          }
        }
      }
    }
  }

  .error {
    font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
    color: ${({ theme }) => theme.COLORS.RED_3};
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    padding-top: 2px;
  }
`;
